{
  "name": "angular-18",
  "version": "7.0.0.27",
  "projectName": "NCache Cloud",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:staging": "ng build --watch --configuration staging"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.8",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "^18.2.0",
    "@angular/localize": "^18.2.7",
    "@angular/material": "^18.2.8",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@faker-js/faker": "^9.0.3",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-svg-core": "^6.6.0",
    "@fortawesome/free-regular-svg-icons": "^6.6.0",
    "@fortawesome/free-solid-svg-icons": "^6.6.0",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ng-idle/core": "^16.0.0",
    "@ng-select/ng-select": "^13.9.0",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.3",
    "country-list": "^2.3.0",
    "google-libphonenumber": "^3.2.40",
    "html-webpack-plugin": "^5.6.0",
    "install": "^0.13.0",
    "intl-tel-input": "^17.0.3",
    "jquery": "^3.7.1",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.11.17",
    "ncache-angular-library": "file:../../ncache-angular-library/ncache-angular-library-0.0.0.tgz",
    "ncache-common-library": "file:../../ncache-angular-library/dist/ncache-common-library/ncache-common-library-0.0.1.tgz",
    "ngx-skeleton-loader": "^9.0.0",
    "ngx-smart-modal": "^14.0.3",
    "ngx-timeago": "^3.0.0",
    "ngx-toastr": "^19.0.0",
    "npm": "^11.0.0",
    "popper.js": "^1.16.1",
    "postcode-validator": "^3.10.2",
    "rxjs": "^7.8.1",
    "save": "^2.9.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.7",
    "@angular/cli": "^18.2.8",
    "@angular/compiler-cli": "^18.2.0",
    "@angular/language-service": "^18.2.7",
    "@types/ip": "^1.1.3",
    "@types/jasmine": "~5.1.0",
    "@types/jasminewd2": "^2.0.13",
    "@types/node": "^22.7.5",
    "angular-in-memory-web-api": "^0.18.0",
    "codelyzer": "^6.0.2",
    "faker": "^6.6.6",
    "jasmine-core": "~5.2.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.49",
    "protractor": "^7.0.0",
    "ts-node": "^10.9.2",
    "tslint": "^6.1.3",
    "typescript": "~5.5.2"
  }
}